module.exports = __webpack_public_path__ + "mobile_study_app.svg?cb01b61bf3a1f89088ad9f7604c48ae3";


//////////////////
// WEBPACK FOOTER
// ./static/mobile_study_app.svg
// module id = 39
// module chunks = 0